module.exports = __webpack_public_path__ + "static/img/noContent.8005c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noContent.png
// module id = eWL0
// module chunks = 1